module.exports = __webpack_public_path__ + "img/tippertruck.250b5857.svg";